// Button IDs for analytics tracking
export const BUTTON_IDS = {
  GET_STARTED: "get-started-button",
  MOBILE_GET_STARTED: "get-started-button",
} as const;

export const NEXT_PUBLIC_POSTHOG_KEY =
  process.env.NEXT_PUBLIC_POSTHOG_KEY ??
  "phc_jfGnQQXrCj07eyU5vIn7SYzvFzsfeNP5Q7av0AN8ddg";
export const NEXT_PUBLIC_POSTHOG_HOST =
  process.env.NEXT_PUBLIC_POSTHOG_HOST ?? "https://us.posthog.com";
export const NEXT_PUBLIC_BASEURL =
  process.env.NEXT_PUBLIC_BASEURL ?? "https://app.hypertask.ai";
export const NEXT_PUBLIC_URL_WITHOUTHTTP =
  process.env.NEXT_PUBLIC_URL_WITHOUTHTTP ?? "app.hypertask.ai";
export const NEXT_PUBLIC_POSTHOG_REVERSE_PROXY = "https://app.hypertask.ai/relay-8ddg"
  //"https://posthog-reverse-proxy-production-f25c.up.railway.app";
